import { clients } from '@/lib/https';
import {
  GetPreSignedUrlForUploadPayload,
  GetPreSignedUrlForUploadResponse,
  IGetFileByFileIDPayload,
  IGetFileByFileIDResponse,
} from '../types/storage.types';

export const getPreSignedUrlForUpload = async (
  payload: GetPreSignedUrlForUploadPayload
): Promise<GetPreSignedUrlForUploadResponse> => {
  const response = await clients.post<GetPreSignedUrlForUploadResponse>(
    '/uds/v1/Files/GetPreSignedUrlForUpload',
    JSON.stringify(payload)
  );
  return response;
};

export const getFileByFileId = async (
  payload: IGetFileByFileIDPayload
): Promise<IGetFileByFileIDResponse> => {
  return clients.get(
    `/uds/v1/Files/GetFile?FileId=${payload.itemId}&ProjectKey=${payload.projectKey}&ConfigurationName=${payload.configurationName ?? ''}`
  );
};
